import { Actions, ActionTypes } from './actions';

export interface State {
    editing: {
        index: number | null;
        loading: boolean;
        error: boolean;
    };
    adding: {
        isAdding: boolean;
        loading: boolean;
        error: boolean;
    };
}

export const initialState: State = {
    editing: {
        index: null,
        loading: false,
        error: false,
    },
    adding: {
        isAdding: false,
        loading: false,
        error: false,
    },
};

export function reducer(state: State = initialState, action: Actions) {
    switch (action.type) {
        case ActionTypes.OpenEditModal:
            return {
                ...state,
                editing: {
                    ...state.editing,
                    index: action.payload.index,
                },
            };

        case ActionTypes.CloseEditModal:
            return {
                ...state,
                editing: {
                    index: null,
                    loading: false,
                    error: false,
                },
            };

        case ActionTypes.OpenAddModal:
            return {
                ...state,
                adding: {
                    ...state.adding,
                    isAdding: true,
                },
            };

        case ActionTypes.CloseAddModal:
            return {
                ...state,
                adding: {
                    ...state.adding,
                    isAdding: false,
                },
            };

        case ActionTypes.EditCustomerAddresses:
            return {
                ...state,
                editing: {
                    ...state.editing,
                    loading: true,
                },
            };

        case ActionTypes.FetchEditCustomerAddressesResponse:
            return {
                ...state,
                editing: {
                    ...state.editing,
                    index: null,
                    loading: false,
                    error: false,
                },
            };

        case ActionTypes.AddCustomerAddresses:
            return {
                ...state,
                adding: {
                    ...state.adding,
                    loading: true,
                },
            };

        case ActionTypes.FetchAddCustomerAddressesResponse:
            return {
                ...state,
                adding: {
                    ...state.adding,
                    loading: false,
                    isAdding: false,
                },
            };

        default:
            return state;
    }
}
